/**
 * Spacing for admin-authored HTML (product description, detail and FAQ).
 *
 * That markup renders inside containers where Tailwind's preflight and Chakra's CSS reset have
 * zeroed every block margin, so paragraphs, headings, lists and <pre> all stack flush against each
 * other. Space the top-level blocks rather than naming tags, so whatever the editor emits keeps a
 * readable rhythm; nested content (list items, inline spans) is deliberately left alone.
 */
const richTextSpacing = {
  '& > *': { marginBottom: '0.75em' },
  '& > *:last-child': { marginBottom: 0 }
}

export default richTextSpacing
